import 'debug';
import { E as EventHub, _ as _asyncToGenerator, h as _regeneratorRuntime } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import Slider from './Slider.js';
import { _ as __vue_normalize__ } from './normalize-component.js';
import { l as lipSync } from './lipSync.js';

var script = {
  mixins: [lipSync],
  props: {
    source: {
      default: ''
    },
    poster: {
      default: ''
    },
    autoPlay: {
      default: false
    },
    loop: {
      default: false
    },
    muted: {
      default: false
    },
    showControls: {
      default: true
    },
    binaryId: null,
    subtitles: null,
    lipSyncUrl: {
      type: String,
      default: null,
      validator: function validator(value) {
        return value === null || (typeof value === 'string' || value instanceof String) && value.startsWith('ws://');
      }
    }
  },
  data: function data() {
    return {
      showVolumeControl: false,
      playing: false,
      progress: 0,
      duration: 0,
      ready: false,
      isSeeking: false,
      sliderVirtualPosition: 0,
      isIos: this.$xp.device.platform === 'ios',
      showSubtitles: false,
      textTrackCueLine: 0
    };
  },
  computed: {
    track: {
      get: function get() {
        if (this.isSeeking && !this.isLipSync) {
          return this.sliderVirtualPosition;
        } else {
          return this.progress;
        }
      },
      set: function set(v) {
        if (this.video) {
          if (!Number.isNaN(v)) {
            this.sliderVirtualPosition = v;
            this.video.currentTime = v * this.duration;
          } else {
            console.log('vPlayer invalid time :' + v);
          }
        }
      }
    },
    playbackVolume: {
      get: function get() {
        return parseFloat(this.$xp.media.volume);
      },
      set: function set(v) {
        this.$xp.media.setGlobalVolume(v);
        this.video.volume = v;
      }
    },
    isLipSync: function isLipSync() {
      return this.lipSyncUrl != null;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var oldVideo = this.$el.querySelector('video');

    if (oldVideo) {
      this.$el.removeChild(oldVideo);
    }

    this.$xp.device.getRemappedUrl(this.source).then(function (remappedUrl) {
      console.log('lipsyncUrl', _this.lipSyncUrl);
      _this.video = document.createElement('video');

      _this.video.classList.add('c-video-player__element'); // if (window.device.platform.toLowerCase() !== 'ios')


      _this.video.controls = false;
      _this.video.src = remappedUrl;
      _this.video.type = 'audio/mp4';
      _this.video.loop = _this.loop;
      _this.video.crossOrigin = 'anonymous';
      _this.video.poster = _this.poster;
      _this.video.disableRemotePlayback = true;

      if (_this.muted) {
        _this.volumeBeforeMute = _this.$xp.media.volume;
        _this.video.volume = 0;
      } else {
        _this.video.volume = _this.$xp.media.volume;
      }

      _this.video.load();

      if (_this.isIos) {
        _this.video.autoPlay = false;
      }

      if (_this.$el.prepend) {
        _this.$el.prepend(_this.video);
      } else {
        _this.$el.insertBefore(_this.video, _this.$el.firstChild);
      }

      _this.video.addEventListener('loadedmetadata', _this.onLoadedMetadata);

      if (_this.isIos) {
        _this.video.addEventListener('webkitbeginfullscreen', _this.enteredFullscreen);

        _this.video.addEventListener('webkitendfullscreen', _this.exitedFullscreen);
      }

      _this.video.addEventListener('canplaythrough', _this.onCanPlayThrough);

      _this.video.addEventListener('play', _this.onVideoPlay);

      _this.video.addEventListener('pause', _this.onVideoPause);

      _this.video.addEventListener('timeupdate', _this.onTimeUpdate);

      _this.video.addEventListener('ended', _this.onVideoEnded);

      _this.video.addEventListener('seeking', _this.onSeeking);

      _this.video.addEventListener('seeked', _this.onSeeked);

      if (_this.subtitles && _this.subtitles.BinaryID !== null) {
        if (_this.$xp.settings.mergedSettings.showSubtitlesDefault) {
          _this.showSubtitles = true;
        } else {
          _this.showSubtitles = _this.$xp.media.showSubtitles;
        }
      }
    });
    EventHub.Bus.$on(EventHub.TYPES.START_PLAY_MEDIA, function (uid) {
      if (_this.video && _this._uid !== uid) {
        _this.video.pause();
      }
    });
    window.addEventListener('keyup', this.onKeyEvent); // if (this.isIos) {
    //   if (window.StatusBar) {
    //     if (window.StatusBar.isVisible) {
    //       console.log('hide while creating video')
    //       window.StatusBar.hide()
    //     } else {
    //       console.log('not visible')
    //     }
    //   }
    // }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isIos) {
      if (!this.$xp.settings.mergedSettings.showSubtitlesDefault) {
        if (this.video.textTracks[0].mode === 'showing' && !this.$xp.media.showSubtitles) {
          this.$xp.media.setShowSubtitles(true);
        } else if (this.video.textTracks[0].mode === 'hidden' && this.$xp.media.showSubtitles) {
          this.$xp.media.setShowSubtitles(false);
        }
      }

      console.log('in ios sub condition, b4destroy in vPlayer');
    }

    this.video.autoplay = false;
    this.video.pause();
    this.$emit('media-session-ended');

    if (this.isLipSync) {
      this.stopLipSync();
      this.$xp.wifi.releaseWifiConnectionOn('videoSync');
    }

    this.video.removeEventListener('loadedmetadata', this.onLoadedMetadata);
    this.video.removeEventListener('canplaythrough', this.onCanPlayThrough);
    this.video.removeEventListener('play', this.onVideoPlay);
    this.video.removeEventListener('pause', this.onVideoPause);
    this.video.removeEventListener('timeupdate', this.onTimeUpdate);
    this.video.removeEventListener('ended', this.onVideoEnded);
    this.video.removeEventListener('seeking', this.onSeeking);
    this.video.removeEventListener('seeked', this.onSeeked);
    this.video.removeEventListener('keyup', this.onKeyEvent);
    EventHub.Bus.$off(EventHub.TYPES.START_PLAY_MEDIA, this.onStartPlayMedia);

    if (this.muted) {
      this.$xp.media.setGlobalVolume(this.volumeBeforeMute);
    }

    this.video.parentNode.removeChild(this.video);
    this.video.removeAttribute('src');
    this.video.load();
    this.video = null; // if (this.isIos) {
    //   if (window.StatusBar.isVisible) {
    //     console.log('StatusBar i s visible, hiding it.')
    //     window.StatusBar.hide()
    //   } else { console.log('not visible') }
    // }
  },
  methods: {
    onLoadedMetadata: function onLoadedMetadata() {
      console.log('onLoadedMetadata', this.video.duration, this.video.currentTime, this.video.play);

      if (this.video) {
        this.duration = this.video.duration;
      }

      if (this.subtitles && this.subtitles.BinaryID !== null) {
        this.loadSubtitles();
        var subButton = document.getElementsByClassName('c-video-player__subtitles-button');

        if (this.showSubtitles) {
          subButton[0].classList.add('c-subButton-active');
        } else {
          subButton[0].classList.add('c-subButton-inactive');
        }
      }
    },
    loadSubtitles: function loadSubtitles() {
      var ttrack = document.createElement('track');
      ttrack.src = this.subtitles.Url;
      ttrack.kind = 'subtitles';
      ttrack.srclang = this.subtitles.srclang;
      ttrack.label = this.subtitles.label;
      ttrack.default = true;
      var oVideo = this.video;
      var self = this;
      ttrack.addEventListener('load', function () {
        console.log('subs are loaded');
        var aCues = oVideo.textTracks[0].cues;

        for (var n = 0; n < aCues.length; n++) {
          aCues[n].line = -1;
          aCues[n].size = 90;
        }

        if (self.showSubtitles) {
          console.log('subs are showing');
          this.mode = 'showing';
        } else {
          console.log('subs are hiding');
          this.mode = 'hidden';
        }

        if (self.isIos) {
          console.log('in load subs', oVideo.webkitClosedCaptionsVisible);
          oVideo.webkitClosedCaptionsVisible = self.showSubtitles;
          console.log('in load subs', oVideo.webkitClosedCaptionsVisible);
        }
      });
      ttrack.className = 'subtitlesTrack';
      this.video.appendChild(ttrack);

      var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
        return p.toString() === '[object SafariRemoteNotification]';
      }(!window['safari'] || typeof window.safari !== 'undefined' && window.safari.pushNotification);

      if (isSafari || this.isIos) {
        console.log('identified Safari');
        this.video.classList.add('stupidSafariSubs');
      }
    },
    onCanPlayThrough: function () {
      var _onCanPlayThrough = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var shouldRestoreState, historyCurrentTime, historyPlayingState;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.video) {
                  _context.next = 19;
                  break;
                }

                if (!this.isLipSync) {
                  _context.next = 10;
                  break;
                }

                if (this.ready) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return this.$xp.wifi.lockWifiConnectionOn('videoSync');

              case 5:
                _context.next = 7;
                return this.$xp.network.waitForOnline();

              case 7:
                this.startLipSync(this.video);

              case 8:
                _context.next = 19;
                break;

              case 10:
                console.log('onCanPlayThrough');
                shouldRestoreState = !this.ready && this.$route.query.ref !== 'beacon';
                console.log('shouldRestoreState: ' + shouldRestoreState);
                historyCurrentTime = this.$xp.history.historyParams['currentTime' + this.binaryId];
                console.log('restore time to = ' + historyCurrentTime);

                if (shouldRestoreState && historyCurrentTime) {
                  console.log('restore time to = ' + historyCurrentTime);
                  this.video.currentTime = historyCurrentTime;
                }

                historyPlayingState = this.$xp.history.historyParams['isPlaying' + this.binaryId];

                if (shouldRestoreState && typeof historyPlayingState !== 'undefined') {
                  historyPlayingState ? this.video.play() : this.video.pause();
                } else if (!this.ready && this.video && this.autoPlay) {
                  this.video.play();
                }

                this.ready = true;

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onCanPlayThrough() {
        return _onCanPlayThrough.apply(this, arguments);
      }

      return onCanPlayThrough;
    }(),
    onVideoPlay: function onVideoPlay() {
      // console.log('onVideoPlay')
      // console.log(this.video)
      this.setPlayingState(true);
      EventHub.Bus.$emit(EventHub.TYPES.START_PLAY_MEDIA, this._uid);
      this.$emit('media-playing');
    },
    onVideoPause: function onVideoPause() {
      // console.log('onVideoPause')
      this.setPlayingState(false);
      this.exitFullscreen();
    },
    setPlayingState: function setPlayingState(isPlaying) {
      this.playing = isPlaying;
      this.$xp.media.setIsMediaPlaying(isPlaying);
      this.$xp.history.setHistoryParam(parseInt(this.$route.params.id), 'isPlaying' + this.binaryId, isPlaying);
    },
    onTimeUpdate: function onTimeUpdate() {
      // console.log('onTimeUpdate')
      if (this.video && this.video.currentTime && this.ready) {
        this.progress = this.video.currentTime / this.video.duration;

        if (Math.floor(this.video.currentTime) % 10 === 0) {
          // postpone dimming every 10 seconds
          this.$xp.screen.postponeDim();
        }

        this.$xp.history.setHistoryParam(parseInt(this.$route.params.id), 'currentTime' + this.binaryId, this.video.currentTime);
      } else {
        // if (!this.isLipSync)
        this.progress = 0;
      }
    },
    onVideoEnded: function onVideoEnded() {
      console.log('onVideoEnded'); // record something if needed

      if (this.video) {
        this.video.pause(); // Jump a little bit back, so on going back to this page onVideoEnded() is not called automatically again

        this.video.currentTime -= 0.1;
        this.onTimeUpdate();
        this.setPlayingState(false);

        if (this.$xp.navigation.childPagesMenuItems.length && this.$xp.navigation.isChildPagesMenuHidden) {
          this.$xp.navigation.toggleChildPagesMenu();
        } else if (this.$xp.navigation.childPagesMenuItems.length === 0 && this.$xp.history.nextPageId && this.$xp.settings.mergedSettings.navigation.nextPageOnMediaEnd) {
          this.$router.push('/page/' + this.$xp.history.nextPageId);
        } else if (this.$xp.navigation.childPagesMenuItems.length === 0 && this.$xp.settings.mergedSettings.navigation.backOnVideoEnd) {
          this.$xp.history.back();
        }
      }
    },
    onSeeking: function onSeeking() {
      // console.log('onSeeking')
      this.isSeeking = true;
    },
    onSeeked: function onSeeked() {
      // console.log('onSeeked')
      this.isSeeking = false;
    },
    onStartPlayMedia: function onStartPlayMedia(uid) {
      if (this.video && this._uid !== uid) {
        this.video.pause();
      }
    },
    togglePlayback: function togglePlayback() {
      // console.log('togglePlayback')
      if (this.video && this.ready) {
        if (!this.playing) {
          this.video.play();
        } else {
          this.video.pause();
        }
      }
    },
    onClickFullscreenPlay: function onClickFullscreenPlay() {
      if (this.video.webkitDisplayingFullscreen) {
        console.log('full screen'); // this.video.webkitExitFullscreen()
      } else {
        console.log('not full screen'); // this.video.webkitRequestFullScreen()

        if (this.video.webkitEnterFullscreen) {
          this.video.webkitEnterFullscreen();
        } else if (this.video.webkitRequestFullscreen) {
          this.video.webkitRequestFullscreen();
        }
      }

      this.togglePlayback();
    },
    exitFullscreen: function exitFullscreen() {
      if (this.isIos) {
        if (this.video.webkitExitFullscreen()) {
          this.video.webkitExitFullscreen();
        }
      }
    },
    enteredFullscreen: function enteredFullscreen() {
      console.log('now full screen');

      if (this.$el.webkitFullscreenElement) {
        console.log(this.$el.webkitFullscreenElement);
      }
    },
    exitedFullscreen: function exitedFullscreen() {
      console.log('exited fullscreen');

      if (this.$el.webkitFullscreenElement) {
        console.log(this.$el.webkitFullscreenElement);
      }
    },
    onKeyEvent: function onKeyEvent(e) {
      var nKey = e.keyCode; // console.log("onKeyEvent " + nKey);

      switch (nKey) {
        case 27:
          // ESC
          console.log('KeyEvent: Audio StopPlay');
          this.video.pause();
          break;

        case 32: // Space

        case 75:
          // K
          console.log('KeyEvent: Video TogglePlay');
          this.togglePlayback();
          break;

        case 37:
          // <-
          console.log('KeyEvent: Video Backward');
          this.video.currentTime -= 15;
          this.onTimeUpdate();
          break;

        case 39:
          // ->
          console.log('KeyEvent: Video Forward');
          this.video.currentTime += 15;
          this.onTimeUpdate();
          break;

        /** NO NEED for volum control in browser */
        // case 38: // arrow up
        //   if (this.$xp.media.showVolumeControl) {
        //     console.log('KeyEvent: Video Volume Up', this.playbackVolume)
        //     this.playbackVolume = Math.min(this.playbackVolume + 1, 200)
        //   }
        //   break
        // case 40: // arrow down
        //   if (this.$xp.media.showVolumeControl) {
        //     console.log('KeyEvent: Video Volume Down', this.playbackVolume)
        //     this.playbackVolume = Math.max(this.playbackVolume - 1, 0)
        //   }
        //   break
      }
    },
    onSubtitlesClick: function onSubtitlesClick() {
      if (this.showSubtitles) {
        this.showSubtitles = false;
        this.video.textTracks[0].mode = 'hidden';
      } else {
        this.showSubtitles = true;
        this.video.textTracks[0].mode = 'showing';
      }

      if (!this.$xp.settings.mergedSettings.showSubtitlesDefault) {
        this.$xp.media.setShowSubtitles(this.showSubtitles);
      }
    }
  },
  components: {
    Slider: Slider
  },
  watch: {
    '$xp.navigation.isNavHidden': function $xpNavigationIsNavHidden(value) {
      if (value === true) {
        this.showVolumeControl = false;
      } // if (this.video.textTracks[0]) {
      //   this.video.cue = ''
      // }

    },
    progress: function progress(value, oldVal) {
      this.$emit('media-progress-changed');

      if (this.subtitles && this.subtitles.BinaryID && this.showSubtitles) {
        var nCueLine = this.$xp.navigation.isNavHidden ? -1 : -3;

        if (nCueLine !== this.textTrackCueLine) {
          // console.log('set Subtitles to line ', nCueLine)
          this.video.textTracks[0].mode = 'hidden';

          for (var i = 0; i < this.video.textTracks[0].cues.length; i++) {
            this.video.textTracks[0].cues[i].line = nCueLine;
          }

          this.video.textTracks[0].mode = 'showing';
          this.textTrackCueLine = nCueLine;
        }
      }
    },
    showSubtitles: function showSubtitles(value) {
      if (this.video.textTracks[0]) {
        if (this.showSubtitles) {
          this.video.textTracks[0].mode = 'showing'; // console.log('in showsubs watch', value)
        } else {
          this.video.textTracks[0].mode = 'hidden'; // console.log('in showsubs watch', value)
        }
      }
    },
    playing: function playing(value) {
      if (this.subtitles) {
        if (this.subtitles.BinaryID) {
          if (this.video.textTracks[0].mode === 'showing' && !this.showSubtitles) {
            this.video.textTracks[0].mode = 'hidden';
          } else if (this.video.textTracks[0].mode === 'hidden' && this.showSubtitles) {
            this.video.textTracks[0].mode = 'showing';
          }
        }
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "c-video-player" }, [
    !_vm.playing && _vm.isIos
      ? _c(
          "div",
          {
            staticClass: "c-video-player__ios-play",
            on: { click: _vm.onClickFullscreenPlay }
          },
          [_c("span", { staticClass: "xp xp-play xp--large" })]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isIos
      ? _c(
          "div",
          {
            staticClass: "c-video-player__controls",
            class: {
              "is-hidden":
                _vm.$xp.navigation.isNavHidden &&
                _vm.showControls &&
                _vm.playing
            },
            attrs: { id: "mediaplayer" }
          },
          [
            _c("div", { staticClass: "c-video-player__wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "c-video-player__duration",
                  attrs: {
                    role: "progressbar",
                    "aria-valuenow": _vm.duration * _vm.progress,
                    "aria-valuemin": "0",
                    "aria-valuemax": _vm.duration
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("formatPlayTime")(
                          _vm.progress * _vm.duration - _vm.duration
                        )
                      ) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-video-player__progress" },
                [
                  _c("slider", {
                    attrs: {
                      value: _vm.track,
                      isMediaProgressSlider: true,
                      isPlaying: _vm.playing,
                      isReady: _vm.ready && !_vm.isSeeking,
                      trackSize: 5,
                      seekable: !_vm.isLipSync
                    },
                    on: {
                      "update:value": function($event) {
                        _vm.track = $event;
                      },
                      pinTap: _vm.togglePlayback
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.subtitles && _vm.subtitles.BinaryID !== null
              ? _c(
                  "button",
                  {
                    class: {
                      "c-video-player__subtitles-button": true,
                      "c-video-player__subtitles-button--shown":
                        _vm.showSubtitles
                    },
                    attrs: { tabindex: _vm.subtitles.BinaryID ? 0 : -1 },
                    on: {
                      click: function($event) {
                        return _vm.onSubtitlesClick()
                      }
                    }
                  },
                  [_c("i", { staticClass: "xp xp--large xp-subtitles" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$xp.media.allowUIVolumeControl
              ? _c(
                  "button",
                  {
                    staticClass: "c-video-player__button",
                    attrs: {
                      tabindex: "0",
                      "aria-label": _vm.$t("global.setVolume")
                    },
                    on: {
                      click: function($event) {
                        _vm.showVolumeControl = !_vm.showVolumeControl;
                      }
                    }
                  },
                  [
                    _vm.$xp.media.volume >= 0.5
                      ? _c("i", { staticClass: "xp xp-volume-up xp--large" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$xp.media.volume < 0.5 && _vm.$xp.media.volume !== 0
                      ? _c("i", { staticClass: "xp xp-volume-down xp--large" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$xp.media.volume === 0
                      ? _c("i", {
                          staticClass: "xp xp-volume-off xp--large",
                          attrs: { name: "$xp.media.volume-off" }
                        })
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showVolumeControl
              ? _c(
                  "div",
                  { staticClass: "c-video-player__volume-control" },
                  [
                    _c("slider", {
                      attrs: {
                        value: _vm.playbackVolume,
                        orientation: "vertical",
                        trackSize: 10,
                        length: 200
                      },
                      on: {
                        "update:value": function($event) {
                          _vm.playbackVolume = $event;
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      : _vm._e()
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
